import revive_payload_client_4sVQNw7RlN from "/webs/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/webs/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/webs/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/webs/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/webs/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/webs/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/webs/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/webs/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/webs/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_ybZ5mczHdl from "/webs/node_modules/nuxt-socket-io/lib/plugin.js";
import after_sale_client_gIULiUWM91 from "/webs/plugins/after-sale.client.ts";
import bi_sa_client_KzrEV1G24y from "/webs/plugins/bi-sa.client.ts";
import compressorImg_client_TycObWflcx from "/webs/plugins/compressorImg.client.ts";
import directive_I6YZ1QHKAO from "/webs/plugins/directive.ts";
import fresh_chat_client_494z6cKxme from "/webs/plugins/fresh-chat.client.ts";
import google_oauth2_client_UrUjE76EHG from "/webs/plugins/google-oauth2.client.ts";
import message_client_gNVFdLD78f from "/webs/plugins/message.client.ts";
import pwa_client_PLDhtd2phb from "/webs/plugins/pwa.client.ts";
import sensors_client_uwsVi32rXD from "/webs/plugins/sensors.client.ts";
import timezone_g7cisNFXCv from "/webs/plugins/timezone.ts";
import util_client_ogVCgxD2pj from "/webs/plugins/util.client.ts";
import utils_EEhlE5KdlH from "/webs/plugins/utils.ts";
import vant_ixkf0x0Irp from "/webs/plugins/vant.ts";
import wap_listing_detail_version_client_FFsJfcZzpt from "/webs/plugins/wap-listing-detail-version.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_ybZ5mczHdl,
  after_sale_client_gIULiUWM91,
  bi_sa_client_KzrEV1G24y,
  compressorImg_client_TycObWflcx,
  directive_I6YZ1QHKAO,
  fresh_chat_client_494z6cKxme,
  google_oauth2_client_UrUjE76EHG,
  message_client_gNVFdLD78f,
  pwa_client_PLDhtd2phb,
  sensors_client_uwsVi32rXD,
  timezone_g7cisNFXCv,
  util_client_ogVCgxD2pj,
  utils_EEhlE5KdlH,
  vant_ixkf0x0Irp,
  wap_listing_detail_version_client_FFsJfcZzpt
]